<div #listContainer>
  <div
    class="tw-grid tw-grid-cols-[auto_1fr] tw-items-center tw-p-3 tw-min-h-[69px]"
  >
    <div>
      <span *ngIf="!actionItemsUserIsAuthUser" class="tw-font-bold">{{(user$ | async).fullName}}</span>
    </div>

    <div class="tw-text-right tw-grid tw-grid-cols-[auto_auto]">
      <mat-form-field class="tw-w-auto" appearance="outline">
        <mat-select [compareWith]="selectCompareFn" [class]="'no-arrow-transform'" [(value)]="selectedTypeIds" (selectionChange)="selectedTypeChanged($event)">
          <mat-select-trigger>{{selectedTypeLabel | truncate:18}}</mat-select-trigger>
          <mat-option [value]="allTypeId">All</mat-option>
          <mat-option [value]="[type.id]" *ngFor="let type of userActionItemTypes$ | async">
            {{type.name}}
            <div *ngIf='requestsBadgeCountsMap && requestsBadgeCountsMap[type.id] as typeCount'
                 class="tw-ml-2 tw-text-sm counter-pill {{typeCount < 10 ? 'single-digit' : ''}}">
              {{ typeCount }}
            </div>
          </mat-option>
          <ng-container *ngIf="showRoleBasedFilters$ | async">
            <mat-option [value]="processorTypeIds">Processor</mat-option>
            <mat-option [value]="subAdminTypeIds">Sub Admin</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="tw-ml-2 tw-w-auto" appearance="outline">
        <mat-select [class]="'no-arrow-transform'" [(value)]="sortDirection" (selectionChange)="resetAndFetch()">
          <mat-option value="desc">Newest to oldest</mat-option>
          <mat-option value="asc">Oldest to newest</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

  </div>

  <mat-list appDynamicScreenHeight class="!tw-p-0 tw-overflow-y-auto">
    <mat-card
      class="!tw-rounded-none mat-elevation-z0 tw-border-b {{ (activeActionItem$ | async)?.id === userActionItem.id ? 'active' : '' }}"
      *ngFor="let userActionItem of userActionItems$ | async"
      (click)="getUserActionItemDetails(userActionItem.id)">
      <mat-card-title class="!tw-text-sm !tw-font-bold">{{userActionItem.type}}</mat-card-title>
      <mat-card-subtitle class="!tw-text-xs tw-absolute tw-top-6 tw-right-6">{{userActionItem.completed ? 'Completed ' + (userActionItem.completed | date) : userActionItem.modified | timeago }}</mat-card-subtitle>
      <mat-card-subtitle>{{userActionItem.name}}</mat-card-subtitle>
    </mat-card>

    <div class="tw-flex tw-p-3 tw-items-center tw-justify-center">
      <mat-spinner diameter="24" *ngIf="( loading$ | async ) else nonLoadingState"></mat-spinner>

      <ng-template #nonLoadingState>
        <span *ngIf="!(userActionItems$ | async).length else loadMoreButton">No Action Items matching this list / filters.</span>
        <ng-template #loadMoreButton>
          <button *ngIf="( showLoadMoreButton$ | async )" mat-stroked-button [color]="'primary'" (click)="loadMore()">Load More</button>
        </ng-template>
      </ng-template>

    </div>

  </mat-list>



</div>
<mat-divider [vertical]="true"></mat-divider>
<div
  *ngIf="(activeActionItem$ | async) as activeItem"
  class="uai-layout-container tw-relative"
>
  <div #resizeBar class="resize-bar tw-w-4 tw-h-full" cdkDrag cdkDragLockAxis="x" (cdkDragMoved)="handleDrag($event)"></div>
  <div [ngSwitch]="activeItem.type">
    <app-document-review *ngSwitchCase="'Document Upload Review'"></app-document-review>
    <app-user-action-item-details *ngSwitchDefault></app-user-action-item-details>
  </div>
  <mat-divider [vertical]="true"></mat-divider>
  <app-user-action-item-borrower-pane></app-user-action-item-borrower-pane>
</div>
